import { c as _c } from "react/compiler-runtime";
import { StarIcon } from '@winelidays/wld-tsx-2/images';
import RatingCount from '../RatingCount';
import RatingNumber from '../RatingNumber';
import StarRating from '../StarRating';
const InlineRatingContent = (t0) => {
    const $ = _c(15);
    const { average, count, short, hideCount } = t0;
    const middleClassName = ` ${short ? "mx-2" : "mx-4"}`;
    const lonelyStarClassName = `text-rating ${middleClassName}`;
    let t1;
    if ($[0] !== average) {
        t1 = <RatingNumber rating={average} className="text-gray-500"/>;
        $[0] = average;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== average || $[3] !== lonelyStarClassName || $[4] !== middleClassName || $[5] !== short) {
        t2 = short ?
            <StarIcon className={lonelyStarClassName}/> :
            <StarRating rating={average} className={middleClassName}/>;
        $[2] = average;
        $[3] = lonelyStarClassName;
        $[4] = middleClassName;
        $[5] = short;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    let t3;
    if ($[7] !== count || $[8] !== hideCount || $[9] !== short) {
        t3 = !hideCount && <RatingCount count={count} short={short} className="text-sm"/>;
        $[7] = count;
        $[8] = hideCount;
        $[9] = short;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    let t4;
    if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
        t4 = <>{t1}{t2}{t3}</>;
        $[11] = t1;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    }
    else {
        t4 = $[14];
    }
    return t4;
};
export default InlineRatingContent;
